import { render, staticRenderFns } from "./individualAnalysis.vue?vue&type=template&id=31ccb76b&scoped=true"
import script from "./individualAnalysis.vue?vue&type=script&lang=js"
export * from "./individualAnalysis.vue?vue&type=script&lang=js"
import style0 from "./individualAnalysis.vue?vue&type=style&index=0&id=31ccb76b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccb76b",
  null
  
)

export default component.exports